const IconEmailSimple = (props) => {
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill={props.fill}
      stroke={props.stroke}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_3463_406210)">
        <path
          d="M2 4L10.1649 9.71544C10.8261 10.1783 11.1567 10.4097 11.5163 10.4993C11.8339 10.5785 12.1661 10.5785 12.4837 10.4993C12.8433 10.4097 13.1739 10.1783 13.8351 9.71544L22 4M6.8 17H17.2C18.8802 17 19.7202 17 20.362 16.673C20.9265 16.3854 21.3854 15.9265 21.673 15.362C22 14.7202 22 13.8802 22 12.2V5.8C22 4.11984 22 3.27976 21.673 2.63803C21.3854 2.07354 20.9265 1.6146 20.362 1.32698C19.7202 1 18.8802 1 17.2 1H6.8C5.11984 1 4.27976 1 3.63803 1.32698C3.07354 1.6146 2.6146 2.07354 2.32698 2.63803C2 3.27976 2 4.11984 2 5.8V12.2C2 13.8802 2 14.7202 2.32698 15.362C2.6146 15.9265 3.07354 16.3854 3.63803 16.673C4.27976 17 5.11984 17 6.8 17Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3463_406210"
          x="-3"
          y="0"
          width="30"
          height="26"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3463_406210"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3463_406210"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default IconEmailSimple
